import type { Result } from 'services/results/types'

import { DEFAULT_DATA_ACCESS_REQUEST_DATASET_COLOR } from '../utils'

export interface GetDataAccessRequestFormCardDataReturn {
  isReady: boolean
  formSubmission?: NonNullable<Result['formSubmission']>
  dataAccessRequest?: NonNullable<Result['dataAccessRequest']>
  requestedAt?: string
  requestingUserEmail?: string
  requesterOrganisationName?: string
  sourceWorkspaceName?: string
  requesterWorkspaceName?: string
  datasetColor: string
}

export const getDataAccessRequestFormCardData = (result: Result): GetDataAccessRequestFormCardDataReturn => {
  const dataAccessRequest = result.dataAccessRequest
  const { formSubmission } = result
  const isReady = formSubmission !== undefined && dataAccessRequest !== undefined

  if (!isReady) {
    return {
      isReady: false,
      datasetColor: DEFAULT_DATA_ACCESS_REQUEST_DATASET_COLOR
    }
  }

  const requestedAt = formSubmission.submittedAt ?? result.startTime ?? result.createdAt
  const datasetColor = dataAccessRequest.datasetColor ?? DEFAULT_DATA_ACCESS_REQUEST_DATASET_COLOR

  return {
    isReady: true,
    formSubmission,
    dataAccessRequest,
    requestedAt,
    requestingUserEmail: result.requestingUser.email,
    requesterOrganisationName: dataAccessRequest.requesterOrganisationName,
    sourceWorkspaceName: dataAccessRequest.sourceWorkspaceName,
    requesterWorkspaceName: dataAccessRequest.requesterWorkspaceName,
    datasetColor
  }
}
